<template>
    <div>
        <h2>Sites Logs</h2>

        <b-table
            :data="siteLogs"
            :mobile-cards="true"
            :debounce-search="400"
            default-sort-direction="desc"
            default-sort="created_at"
            :striped="true"
            per-page="10"
            :paginated="true"
        >
            <b-table-column field="id" width="1.2em" sortable searchable label="Id" cell-class="align-middle">
                <div slot="default" slot-scope="props">#{{ props.row.id }}</div>

                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <input
                            v-model="props.filters[props.column.field]"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Id..."
                        />
                    </div>
                </div>
            </b-table-column>
            <b-table-column field="site" searchable label="Site" cell-class="align-middle">
                <div slot="default" slot-scope="props">#{{ props.row.site_id }} - {{ props.row.site.url }}</div>

                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <input
                            v-model="props.filters[props.column.field]"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Site..."
                        />
                    </div>
                </div>
            </b-table-column>
            <b-table-column field="status" sortable searchable label="Statut" cell-class="align-middle">
                <div slot="default" slot-scope="props">
                    <TagEditable :init-value="props.row.status" :note-id="props.row.id" @input-blur="updateStatus" />
                </div>

                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <input
                            v-model="props.filters[props.column.field]"
                            type="text"
                            class="form-control form-control-sm"
                            :placeholder="$t('global.ref') + '...'"
                        />
                    </div>
                </div>
            </b-table-column>
            <b-table-column field="type" searchable label="Type" cell-class="align-middle">
                <div slot="default" slot-scope="props">
                    {{ props.row.type }} <br />
                    <small v-if="props.row.type != 'Action'">(Note libre)</small>
                </div>

                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <input
                            v-model="props.filters[props.column.field]"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Type..."
                        />
                    </div>
                </div>
            </b-table-column>
            <b-table-column field="notes" searchable label="Notes" cell-class="align-middle">
                <div slot="default" slot-scope="props">
                    {{ props.row.notes }}
                </div>

                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <input
                            v-model="props.filters[props.column.field]"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Note..."
                        />
                    </div>
                </div>
            </b-table-column>
            <b-table-column field="admin" searchable label="Admin" cell-class="align-middle">
                <div slot="default" slot-scope="props">
                    {{
                        props.row.admin_note.role === 'admin'
                            ? `Admin: ${props.row.admin_note.user}`
                            : `Partenaire: ${user.user}`
                    }}
                </div>

                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <input
                            v-model="props.filters[props.column.field]"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Utilisateur..."
                        />
                    </div>
                </div>
            </b-table-column>
            <b-table-column field="created_at" sortable searchable label="Date" cell-class="align-middle">
                <div slot="default" slot-scope="props">
                    {{ moment(props.row.created_at).format('DD/MM/YYYY') }}
                </div>

                <div slot="searchable" slot-scope="props">
                    <div class="w-100">
                        <input
                            v-model="props.filters[props.column.field]"
                            type="date"
                            class="form-control form-control-sm"
                            placeholder="Date..."
                        />
                    </div>
                </div>
            </b-table-column>
        </b-table>
    </div>
</template>

<script>
    import TagEditable from './EditableTag'

    export default {
        name: 'SiteLogTable',
        components: { TagEditable },
        props: {
            siteLogs: []
        },
        methods: {
            updateStatus(data) {
                this.axios
                    .patch(`/admin/note/site/${data.id}`, data)
                    .then(() => {
                        this.$emit('reload')
                    })
                    .catch(e => {
                        this.$store.dispatch('toastError', e)
                    })
            }
        }
    }
</script>
